const axios = require("axios");
/* NodeJS */
const url = process.env.REACT_APP_BASE_FINGI_CORE_BASE_URL;

module.exports = {
  getPublishableKey: (accessToken, propertyUid) =>
    axios({
      method: "GET",
      url: `${url}/verification_sessions/publishable_key?property_uid=${propertyUid}`,
      headers: { Authorization: `Bearer ${accessToken}` },
    }),
  generateSession: (accessToken, propertyUid, bookingNumber, userNationality) =>
    axios({
      method: "POST",
      url: `${url}/verification_sessions`,
      headers: { Authorization: `Bearer ${accessToken}` },
      data: {
        property_uid: propertyUid,
        booking_number: bookingNumber,
        user_nationality: userNationality,
      },
    }),
  retrieveVerificationSession: (
    accessToken,
    propertyUid,
    verificationSession
  ) =>
    axios({
      method: "get",
      url: `${url}/verification_sessions/${verificationSession}?property_uid=${propertyUid}&access_token=${accessToken}`,
      headers: { Authorization: `Bearer ${accessToken}` },
    }),
};
